<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">New Debit Note</h4>
                <p class="text-subtitle-1">Supplier Debit Note Creation Form</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>            
            <v-col cols="12" md="3">
                <v-btn depressed block @click="exchangeRateIndexShown = true">
                    <v-icon left>mdi-chart-areaspline-variant</v-icon>
                    currency exchange
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <DebitNoteForm 
                    v-model="data"
                    ref="form"
                    :exchange-rate-index-shown.sync="exchangeRateIndexShown"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="3">
                <v-btn block class="primary" @click="handleSave">
                    <v-icon left>mdi-content-save</v-icon>
                    save
                </v-btn>
            </v-col>
            <v-col cols="12" md="3">
                <v-btn block depressed @click="handleCancel">
                    cancel                    
                </v-btn>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions';
import LoadingOverlay from './../../components/common/LoadingOverlay.vue'
import PAlert from './../../components/common/PAlert.vue'
import DebitNoteForm from '@/components/purchase/DebitNoteForm' 
import { mapActions, mapGetters } from 'vuex'
import { v4 as uuid } from 'uuid';

export default {
    name: "DebitNoteCreateView",
    components: {
        DebitNoteForm,
        PAlert,
        LoadingOverlay
    },
    data() {
        return {
            loading: false,
            data: null,
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            perm: permissions,
            idempotentKey: null,
            exchangeRateIndexShown: false
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            create: "purchase/debitNote/create",
            snackbar: "ui/snackbar/show"
        }), 
        handleSave() {
            this.alert = {...this.alert , value: true, content: "Are you sure you want to save?", callback: this.save}
        },
        handleNewLine() {
            this.$refs.form.addLine()
        },
        handleList() {
            this.$router.push({ name: "DebitNoteList"})
        },
        save() {
            if(!this.$refs.form.validate()) return;
            this.loading = true
            this.create({...this.data, idempotentKey: this.idempotentKey}).then(response => {
                this.$router.push({ name: "DebitNoteDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Debit Note create succesfuly", color: "success"})
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({text: message, color: "error"})
            }).finally(() => {
                this.loading = false
            })
        },
        handleCancel() {
            this.alert = {...this.alert , value: true, content: "Are you sure you want to discard changes?", callback: this.cancel}
        },
        cancel() {
            this.$router.back();
        }
    },
    mounted() {
        this.$refs.form.addLine();
    },
    created() {
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>